import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from './assets/OS logo inverted.png';
import mailIcon from './assets/mail-icon.png';
import instagramIcon from './assets/instagram-icon.png';
import './ConstitutionPage.css';

function NewsletterPage() {

  return (
    <div className="NewsletterPage">
      <header className="Newsletter-header">
        <Link to="/" className="logo-link">
          <img src={logo} className="Newsletter-logo" alt="logo" />
        </Link>
        <h1>Outer Spaces Constitution</h1>
        
  <section>
        <h2>1. Name</h2>
        <p>The name of the group shall be: <strong>Outer Spaces</strong></p>
    </section>

    <section>
        <h2>2. Purpose</h2>
        <p>The purpose of Outer Spaces is to:</p>
        <ul>
            <li>Document and celebrate the Sheffield music scene and other UK music communities.</li>
            <li>Provide a platform for artists performing original material in unique and interesting spaces.</li>
            <li>Share recorded sessions online to encourage cross-discovery of artists and foster collaboration.</li>
            <li>Engage the local community through live events, workshops, and other collaborations.</li>
        </ul>
    </section>

    <section>
        <h2>3. Membership</h2>
        <p>Outer Spaces does not operate a formal membership system. Participation is open to artists, volunteers, and collaborators who support the aims of the group.</p>
    </section>

    <section>
        <h2>4. Management and Decision-Making</h2>
        <p>Outer Spaces is managed by the Founder (Benjamin Wilson). Volunteers may assist with projects, but final decisions rest with the Founder. Community input will be sought through polls and questions on social media where appropriate.</p>
    </section>

    <section>
        <h2>5. Finance</h2>
        <p>Outer Spaces operates as a non-profit organisation. All funds received through grants or other sources will be used solely for:</p>
        <ul>
            <li>Specific projects</li>
            <li>Hiring spaces</li>
            <li>Improving equipment</li>
        </ul>
        <p>The Founder will maintain records of income and expenditure. Any personal contributions by the Founder are voluntary and non-recoverable.</p>
    </section>

    <section>
        <h2>6. Core Tennets</h2>
        <ol>
          <li>All recorded sessions must feature original material or traditional folk songs performed by the artists live for the session.</li>
          <li>Artist will not be charged for the session. Artist are chosen on merit not finances</li>
          <li>Sessions should be recorded in unique, interesting, or meaningful spaces where possible.</li>
          <li>Outer Spaces will not accept payment or sponsorship from brands or corporations that conflict with the values of the group.</li>
          <li>Respect and inclusivity are core to the channel.</li>
        </ol>
    </section>
    <section>
        <h2>7. Dissolution</h2>
        <p>If Outer Spaces ceases to operate, any remaining funds will be donated to a charity or community group with similar aims.</p>
    </section>


        <div className="social-links">
          <a href="mailto:contact@example.com" className="mail-link">
            <img src={mailIcon} alt="Mail Icon" className="mail-icon" />
          </a>
          <a
            href="https://www.instagram.com/outer_spaces_sessions/"
            target="_blank"
            rel="noopener noreferrer"
            className="instagram-link"
          >
            <img
              src={instagramIcon}
              alt="Instagram Icon"
              className="instagram-icon"
            />
          </a>
        </div>

        <Link to="/" className="back-link">
          ← Back to Sessions
        </Link>
      </header>
    </div>
  );
}

export default NewsletterPage;
